import React from "react";

interface IconProps {
  color?: string;
}

const EditAltIcon: React.FC<IconProps> = ({ color = "#236BCF" }) => {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6066 3.5C14.7392 3.5 14.8664 3.55268 14.9602 3.64645L17.7886 6.47487C17.9838 6.67014 17.9838 6.98672 17.7886 7.18198L8.59618 16.3744C8.53336 16.4372 8.45494 16.4821 8.36899 16.5046L4.54056 17.5046C4.36882 17.5494 4.18616 17.4999 4.06065 17.3744C3.93513 17.2489 3.88557 17.0662 3.93043 16.8945L4.93043 13.066C4.95288 12.9801 4.99783 12.9017 5.06065 12.8388L14.253 3.64645C14.3468 3.55268 14.474 3.5 14.6066 3.5Z"
        fill={color}
      />
      <path
        d="M4 19.25C3.58579 19.25 3.25 19.5858 3.25 20C3.25 20.4142 3.58579 20.75 4 20.75H19C19.4142 20.75 19.75 20.4142 19.75 20C19.75 19.5858 19.4142 19.25 19 19.25H4Z"
        fill={color}
      />
    </svg>
  );
};

export default EditAltIcon;
